import { render } from "./ModernContent.vue?vue&type=template&id=71391063&scoped=true"
import script from "./ModernContent.vue?vue&type=script&lang=js"
export * from "./ModernContent.vue?vue&type=script&lang=js"

import "./ModernContent.vue?vue&type=style&index=0&id=71391063&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71391063"]])

export default __exports__